
<div class="step-container" >
  




    <ng-template #labelOne>Seva Profile </ng-template>
    <nb-accordion multi>


      <nb-accordion-item>
        <nb-accordion-item-header>
          Personal Detail
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.PersonalDetails">
          <app-personal-detail   [isPreviewMode]="true"  [applicantData]="applicantData.PersonalDetails"></app-personal-detail>
        </nb-accordion-item-body>
      </nb-accordion-item>



      <nb-accordion-item>
        <nb-accordion-item-header>
          Language Proficiency
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.UserLanguages" >
          <app-langauge [isPreviewMode]="true"  [applicantData]="applicantData.UserLanguages"></app-langauge>
        </nb-accordion-item-body>
      </nb-accordion-item>





      <nb-accordion-item>
        <nb-accordion-item-header>
          Address 
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.CurrentAddress">
          <app-address-section  [isPreviewMode]="true"  [applicantData]="applicantData"></app-address-section>
        </nb-accordion-item-body>
      </nb-accordion-item>


     



      
      <nb-accordion-item>
        <nb-accordion-item-header>
          Educational and Work Experience
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.EducationalAndWorkExperience">
          <!-- <app-address-section  [isPreviewMode]="true"  [applicantData]="applicantData.CurrentAddress"></app-address-section> -->
       

          <app-educational-and-workexperience  [isPreviewMode]="true"  [applicantData]="applicantData.EducationalAndWorkExperience"></app-educational-and-workexperience>
       
       
        </nb-accordion-item-body>
      </nb-accordion-item>









      <nb-accordion-item>
        <nb-accordion-item-header>
          Siddha Yoga Participation
        </nb-accordion-item-header>
        <nb-accordion-item-body  *ngIf="applicantData?.CurrentParticipation">
          <app-study-participation-information [isPreviewMode]="true"  [applicantData]="applicantData.CurrentParticipation"></app-study-participation-information>
        </nb-accordion-item-body>
      </nb-accordion-item>





      <nb-accordion-item>
        <nb-accordion-item-header>
          Other Personal Information
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.SpiritualHistory">
     <app-other-personal-information [isPreviewMode]="true"  [applicantData]="applicantData.SpiritualHistory"></app-other-personal-information>
  
        </nb-accordion-item-body>
      </nb-accordion-item>










      <nb-accordion-item>
        <nb-accordion-item-header>
          References
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.Reference">
          <app-references  [isPreviewMode]="true"  [applicantData]="applicantData.Reference"></app-references>
        </nb-accordion-item-body>
      </nb-accordion-item>





      <nb-accordion-item>
        <nb-accordion-item-header>
          Medical History
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.MedicalHistory">
          <app-medical-history [isPreviewMode]="true"  [applicantData]="applicantData.MedicalHistory" ></app-medical-history>
        </nb-accordion-item-body>
      </nb-accordion-item>







      <nb-accordion-item>
        <nb-accordion-item-header>
          Physical Ability
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.PhysicalAbility" >
          <app-physical-ability [isPreviewMode]="true"  [applicantData]="applicantData.PhysicalAbility"></app-physical-ability>
        </nb-accordion-item-body>
      </nb-accordion-item>



      <nb-accordion-item>
        <nb-accordion-item-header>
          Physical Fitness
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.PhysicalCapability" >
          <app-physical-fitness [isPreviewMode]="true"  [applicantData]="applicantData.PhysicalCapability"></app-physical-fitness>
        </nb-accordion-item-body>
      </nb-accordion-item>


      <nb-accordion-item>
        <nb-accordion-item-header>
          Hospital Admissions & Allergies
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.HospitalAdmissionDetails">
          <app-hospital-and-allergies [isPreviewMode]="true"  [applicantData]="applicantData.HospitalAdmissionDetails"></app-hospital-and-allergies>
        </nb-accordion-item-body>
      </nb-accordion-item>


      <nb-accordion-item>
        <nb-accordion-item-header>
          Health Insurance
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.HealthInsurance" >
          <app-health-insurance [isPreviewMode]="true"  [applicantData]="applicantData.HealthInsurance"></app-health-insurance>
        </nb-accordion-item-body>
      </nb-accordion-item>






      <nb-accordion-item>
        <nb-accordion-item-header>
          Upload documents
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.PersonalDetails">
          <app-document   [isPreviewMode]="true"  [applicantData]="applicantData.UserDocuments"></app-document>
        </nb-accordion-item-body>
      </nb-accordion-item>




      <nb-accordion-item>
        <nb-accordion-item-header>
          APPLICANT AGREEMENTS, UNDERTAKINGS AND ACKNOWLEDGEMENTS
        </nb-accordion-item-header>
        <nb-accordion-item-body *ngIf="applicantData?.UserConsent">


          <app-seva-profile-aggrement  [isPreviewMode]="true"  [applicantData]="applicantData.UserConsent"></app-seva-profile-aggrement>


        </nb-accordion-item-body>
      </nb-accordion-item>




    </nb-accordion>
  </div>
